module.exports = __webpack_public_path__ + "img/cloudy-day-3.109368f6.svg";